import { render, staticRenderFns } from "./smsTextarea.vue?vue&type=template&id=3643d1e2&scoped=true&"
import script from "./smsTextarea.vue?vue&type=script&lang=js&"
export * from "./smsTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3643d1e2",
  null
  
)

export default component.exports